<!-- 主体变更协议 -->
<template>
  <div class="subjectChangeAgreement-container">
    <article>
      <section>
        <div>甲方：{{ agreementInfo.qualificationName }}</div>
        <div>地址：{{ agreementInfo.partyaAddress }}</div>
        <div>联系人：{{ agreementInfo.partyaContract }}</div>
        <div>联系电话：{{ agreementInfo.partyaMobileNo }}</div>
        <div>联系邮箱：{{ agreementInfo.partyaEmail }}</div>
      </section>
      <section>
        <div>乙方：{{ agreementInfo.partybName }}</div>
        <div>地址：{{ agreementInfo.partybAddress }}</div>
        <div>联系人：{{ agreementInfo.partybContract }}</div>
        <div>联系电话：{{ agreementInfo.partybMobileNo }}</div>
        <div>联系邮箱：{{ agreementInfo.partybEmail }}</div>
      </section>
      <section>
        <div>丙方：{{ agreementInfo.partycName }}</div>
        <div>地址：{{ agreementInfo.partycAddress }}</div>
        <div>联系人：{{ agreementInfo.partycContract }}</div>
        <div>联系电话：{{ agreementInfo.partycMobileNo }}</div>
        <div>联系邮箱：{{ agreementInfo.partycEmail }}</div>
      </section>
      <section>
        1、针对甲乙双方就充电宝业务合作所签署的相关协议及协议项下附件（无论一个或多个，统称“原合同”），现由于乙方业务调整，三方达成一致，原合同剩余有效期内，乙方将原合同项下权利义务概括转移至丙方承受，丙方将代替乙方遵守原合同相关约束，享有原合同项下权利、履行原合同项下义务。
      </section>
      <section>
        2、本协议生效后，即构成“原合同”的有效变更，与“原合同”具有同等的法律效力。除本协议中明确所作修改的条款之外，“原合同”的其他条款继续有效。本协议与原合同有冲突时，以本协议为准。
      </section>
      <section>
        3、本协议由甲、乙、丙三方盖章确认，于 <span class="date">{{ agreementInfo.effectiveDate || '' }}</span> 生效（如盖章日期晚于前述日期的，则追溯至前述日期生效）。本协议原件一式叁份，甲、乙、丙三方各执壹份，具有同等法律效力。
      </section>
      <section>
        <div>甲方：{{ agreementInfo.qualificationName }}</div>
        <div>签署日期：{{ agreementInfo.todayDate }}</div>
      </section>
      <section>
        <div>乙方：{{ agreementInfo.partybName }}</div>
        <div>签署日期：{{ agreementInfo.todayDate }}</div>
      </section>
      <section>
        <div>丙方：{{ agreementInfo.partycName }}</div>
        <div>签署日期：{{ agreementInfo.todayDate }}</div>
      </section>
    </article>
  </div>
</template>

<script>
import AgreementApi from '@/api/agreement';
import STATUS from '@/constants/status';

export default {
  name: 'SubjectChangeAgreement',

  data() {
    return {
      agreementInfo: {},
    };
  },
  async created() {
    document.body.style.background = '#FFF';
    this.getData();
  },
  beforeRouteLeave(to, from, next) {
    document.body.style.background = '';
    next();
  },
  methods: {
    async getData() {
      this.$store.commit('setLoading', true);

      try {
        const partnerId = this.$store.getters['partnerModule/id'];
        const { data, code, error } = await AgreementApi.getChangeSubjectAgreementDetail({
          partnerId,
        });

        if (code !== STATUS.SUCCESS) throw new Error(error.msg);

        this.agreementInfo = data;
      } catch (e) {
        this.$dialog.toast(e.message || '操作失败');
      } finally {
        this.$store.commit('setLoading', false);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.subjectChangeAgreement-container {
  padding: 30px 36px;
  font-family: PingFang SC;
  font-size: 30px;
  color: rgba(0,0,0,0.84);
  letter-spacing: 0;
  text-align: justify;
  line-height: 45px;
  article {
    .bolder {
      font-weight: 600;
    }
    section:not(:last-of-type) {
      margin-bottom: 30px;
    }
  }

  .date {
    text-decoration: underline;
  }
}
</style>
